export default __webpack_public_path__ + "static/media/legao.b02efc07.svg";